<template>
  <LcModal
    v-bind="{ isVisible }"
    background-class="acknowledgement-fullscreen__modal--background"
    :close-triggers="['click-outside', 'escape']"
    :tracking="{
      topicKey: 'acknowledgement',
    }"
    transition="slide-down-lg"
    @close="handleClose"
  >
    <template #modal="{ setRef }">
      <LcCard
        :ref="setRef"
        body-class="flex flex-col h-full p-none"
        class="state-switch__card lc-modal__card lc-modal__card--large"
        data-containerid="state_picker"
        role="dialog"
      >
        <header
          class="flex items-center justify-between p-100 headline-h5-headline"
        >
          <h5 class="headline-h5-headline">{{ title }}</h5>

          <LcButton
            icon="close"
            size="small"
            variant="tertiary"
            @click="handleClose"
          />
        </header>

        <CmsContent
          class="cms-content flex flex-col h-full px-100"
          :data="pageData"
        />
      </LcCard>
    </template>
  </LcModal>
</template>

<script lang="ts" setup>
import type { ContentBlock } from '~~/@types/generated/cms/graphql-schema-types'

import type { AcknowledgementPage } from '../types'

type TermsAndPrivacyFullscreenModalProps = {
  type: AcknowledgementPage
}

const props = defineProps<TermsAndPrivacyFullscreenModalProps>()

const isVisible = defineModel('isVisible', { default: false, type: Boolean })

const isContentBlock = (property: unknown): property is ContentBlock =>
  (property as ContentBlock).__typename === 'ContentBlock'

const { data, error } = useContent().getPage(props.type)

const title = computed(() => data.value?.title || '')
const pageData = computed(
  () => data.value?.contentBlocksCollection?.items.filter(isContentBlock) ?? [],
)

const handleClose = () => {
  isVisible.value = false
}

watchImmediate(error, () => {
  if (!error.value) return
  show404Error()
})
</script>

<style lang="scss">
.acknowledgement-fullscreen {
  &__card {
    overflow: hidden;
    background-color: token('color/background/secondary/secondary/bold');

    @include media-tablet {
      height: 100%;
      border-radius: 0;
    }
  }

  &__modal {
    &--background {
      padding: 4rem;

      @include media-tablet {
        padding: 0;
        background: none;
        backdrop-filter: none;
      }
    }
  }
}

.cms-content {
  overflow-y: auto;
}
</style>
